interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

export default function SEOHead({
  title = '韩漫在线 - 韩漫下拉式在线阅读 - 免费韩国漫画大全 - 奇漫屋',
  description = '奇漫屋提供免费韩国漫画大全，支持在线和下拉式阅读，随时访问最新韩漫资源，发现无数精彩故事等待您的探索。',
  keywords = '韩漫在线, 下拉式阅读, 免费韩国漫画, 奇漫屋',
  canonicalUrl = 'https://qimanwu.com',
  ogTitle,
  ogDescription,
  ogType = 'website',
}: SEOHeadProps) {
  const finalOgTitle = ogTitle || title;
  const finalOgDescription = ogDescription || description;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="奇漫屋" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
    </>
  );
}